module.exports = __webpack_public_path__ + "static/media/room-joining.f06feb28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-joining.png
// module id = 2245
// module chunks = 0